<template>
  <div class="btn-group street-selector">
    <button
      class="btn btn-default"
      v-bind:class="{ 'active': street === 'flop' }"
      v-bind:disabled="!authorized"
      v-on:click="$emit('setStreet', 'flop')"
    >
      Flop
    </button>
    <button
      class="btn btn-default"
      v-bind:class="{ 'active': street === 'turn' }"
      v-bind:disabled="!authorized"
      v-on:click="$emit('setStreet', 'turn')"
    >
      Turn
    </button>
    <button
      class="btn btn-default"
      v-bind:class="{ 'active': street === 'river' }"
      v-bind:disabled="!authorized"
      v-on:click="$emit('setStreet', 'river')"
    >
      River
    </button>
  </div>
</template>

<script>
export default {
  name: 'street-selector',
  props: ['street', 'authorized'],
};
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/guided-analyses/street-selector.vue